import React from "react";
export default function Terms({ ssr_data_tribe, content }) {
  return (
    <>
      <div className="mx-auto max-w-[800px] ">
        <div
          className="text-gray-300 markdown mb-[50px]"
          dangerouslySetInnerHTML={{
            __html: content,
          }}
        />
      </div>
    </>
  );
}
